const notifyUser = (message: string) => {
  document.querySelector('.clipboard-notification')?.remove();
  const notification = document.createElement('div');
  notification.textContent = message;
  notification.className = 'clipboard-notification';
  notification.setAttribute('role', 'status');
  document.body.appendChild(notification);
  setTimeout(() => {
    notification.remove();
  }, 2000);
};

const handleCopyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    notifyUser('Text copied to clipboard');
  } catch (err) {
    notifyUser('Error in copying text');
  }
};

export {
  handleCopyToClipboard,
  notifyUser,
};
